"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The names of the common string constants you can use as HTML attributes for the tableau web component.
 * @ignore
 */
var WebComponentAttributes;
(function (WebComponentAttributes) {
    WebComponentAttributes["Src"] = "src";
    WebComponentAttributes["Width"] = "width";
    WebComponentAttributes["Height"] = "height";
    WebComponentAttributes["Token"] = "token";
    WebComponentAttributes["Debug"] = "debug";
    WebComponentAttributes["IframeAuth"] = "iframe-auth";
    WebComponentAttributes["OnVizLoadError"] = "onvizloaderror";
    WebComponentAttributes["ForceTokenSync"] = "force-token-sync";
})(WebComponentAttributes = exports.WebComponentAttributes || (exports.WebComponentAttributes = {}));
/**
 * The names of the embedded iframe attributes whose values can be controlled.
 * @ignore
 */
var EmbeddedIframeAttributes;
(function (EmbeddedIframeAttributes) {
    EmbeddedIframeAttributes["Loading"] = "iframe-attr-loading";
    EmbeddedIframeAttributes["Style"] = "iframe-attr-style";
    EmbeddedIframeAttributes["Class"] = "iframe-attr-class";
})(EmbeddedIframeAttributes = exports.EmbeddedIframeAttributes || (exports.EmbeddedIframeAttributes = {}));
/**
 * The names of the string constants you can use as child tags for TableauViz, TableauAuthoringViz and TableauAskData custom elements.
 * @ignore
 */
var WebComponentChildElements;
(function (WebComponentChildElements) {
    /**
     * Contains a list of custom parameters.  Available in viz viewing, viz authoring and askdata.
     */
    WebComponentChildElements["CustomParameter"] = "custom-parameter";
    /**
     * Custom styles applicable to the embedded iframe element itself (not inside it).
     */
    WebComponentChildElements["IframeStyle"] = "iframe-style";
})(WebComponentChildElements = exports.WebComponentChildElements || (exports.WebComponentChildElements = {}));
var WebComponentChildElementAttributes;
(function (WebComponentChildElementAttributes) {
    WebComponentChildElementAttributes["Field"] = "field";
    WebComponentChildElementAttributes["Value"] = "value";
    WebComponentChildElementAttributes["Name"] = "name";
})(WebComponentChildElementAttributes = exports.WebComponentChildElementAttributes || (exports.WebComponentChildElementAttributes = {}));
//# sourceMappingURL=WebComponentInterfaces.js.map